import {
  FETCH_TECHNOLOGIES_REQUEST,
  FETCH_TECHNOLOGIES_SUCCESS,
  FETCH_TECHNOLOGIES_FAILURE,
  SAVE_TECHNOLOGY_REQUEST,
  SAVE_TECHNOLOGY_SUCCESS,
  SAVE_TECHNOLOGY_FAILURE,
  DELETE_TECHNOLOGY_REQUEST,
  DELETE_TECHNOLOGY_SUCCESS,
  DELETE_TECHNOLOGY_FAILURE,
} from './types';

const INITIAL_STATE = {
  technologyList: [],
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_TECHNOLOGIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_TECHNOLOGIES_SUCCESS:
      return {
        ...state,
        loading: false,
        technologyList: action.payload,
      };

    case FETCH_TECHNOLOGIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        technologyList: [],
      };
    case SAVE_TECHNOLOGY_REQUEST:
      return {
        ...state,
        error: null,
      };

    case SAVE_TECHNOLOGY_SUCCESS:
      return {
        ...state,
      };

    case SAVE_TECHNOLOGY_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case DELETE_TECHNOLOGY_REQUEST:
      return {
        ...state,
        error: null,
      };

    case DELETE_TECHNOLOGY_SUCCESS:
      return {
        ...state,
      };

    case DELETE_TECHNOLOGY_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
